import { PaginationPcApiResponse } from '@/api/pc-api/types';
import { DEFAULT_PAGE_SIZE } from '@/constants/pagination';
import { SvcReviewStatusType } from '@/constants/svc';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  partnerId: string;
  page: number;
  size?: number;
};
export type Service = {
  contractCount: number;
  id: string;
  reviewStatus: SvcReviewStatusType;
  svcName: string;
};

export const getPartnerDetailsSvcList = ({ partnerId, page, size = DEFAULT_PAGE_SIZE }: Args) => {
  return api<PaginationPcApiResponse<Service[]>>('get', `/pc-api/v1/${PREFIX_PATH}/partner/details/svc-list`, {
    partnerId,
    page,
    size
  });
};
